import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import TeamContext, { useTeam } from '../../../config/context/team'
import { ApplicationForm } from '../../TeamDashboard/subpages/TeamApplicants/components/ApplicationForm'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  team: wowaudit.Team
}

const RecruitmentFormPreviewDialog = ({ open, onOpenChange, team }: Props) => {
  const { guild, refetchTeamDetails } = useTeam()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='max-w-3xl'>
        <DialogHeader>
          <DialogTitle>Application form preview</DialogTitle>
        </DialogHeader>

        {open ? (
          <TeamContext.Provider value={{ guild, team, refetchTeamDetails }}>
            <ApplicationForm inDashboard preview editing={false} />
          </TeamContext.Provider>
        ) : null}
      </DialogContent>
    </Dialog>
  )
}

export default RecruitmentFormPreviewDialog
